import { PlusSquareIcon } from '@phosphor-icons/react';
import queryString from 'query-string';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { MasksTable } from '../components';
import { Mask } from '../types';

export const MasksPage: FC = () => {
  const navigate = useNavigate();

  const redirectToStyleDetails = (item) => {
    navigate(Routes.MaskDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Masks"
        actions={[
          <Link
            to={Routes.NewMask}
            key="new-mask"
            data-testid="add-new-mask-link"
          >
            <Button data-testid="add-new-mask-button">
              <PlusSquareIcon />
              Add new mask
            </Button>
          </Link>,
        ]}
      />

      <MasksTable onClick={redirectToStyleDetails} />
    </div>
  );
};
